<script setup>
// import SpinnerHtml from "../components/SpinnerHtml.vue"
</script>
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center p-3 my-3 text-dark-50 bg-lightblue rounded shadow-sm">
          <div class="lh-100">
            <h6 class="border-bottom border-gray pb-2 mb-0 lh-100">Block List</h6>
          </div>
          <button type="submit" class="btn btn-success ml-auto" @click="openModelClickMethod"
                  data-toggle="modal"
                  data-target="#exampleModal">
            <span> &#43; &nbsp;Block</span>
          </button>
        </div>
        <!--                <div class="table-responsive">-->
        <!--                    <table class="table">-->
        <!--                        <thead class="text-bold">-->
        <!--                        <tr>-->
        <!--                            <th scope="col">#</th>-->
        <!--                            <th scope="col">PHONE NUMBER</th>-->
        <!--                            <th scope="col">REASON</th>-->
        <!--                            <th scope="col">CBY</th>-->
        <!--                            <th scope="col">DATETIME</th>-->
        <!--                            <th scope="col">ACTION</th>-->
        <!--                        </tr>-->
        <!--                        </thead>-->
        <!--                        <tbody>-->
        <!--                        <tr v-for="(row, index) in tables" :key="row.id">-->
        <!--                            <td scope="row">{{ index + 1 }}</td>-->
        <!--                            <td>{{ row.phonenumber }}</td>-->
        <!--                            <td>{{ row.reason }}</td>-->
        <!--                            <td>{{ row.cby }}</td>-->
        <!--                            <td>{{ format_date(row.timestamp) }}</td>-->
        <!--                            <td>-->
        <!--                                <button type="button" @click="integrationAction(index, 'edit')" class="btn btn-success"-->
        <!--                                        data-toggle="modal"-->
        <!--                                        data-target="#exampleModal">Edit-->
        <!--                                </button>-->
        <!--                                <button type="button" @click="integrationAction(index, 'delete')"-->
        <!--                                        class="btn btn-danger">Delete-->
        <!--                                </button>-->
        <!--                            </td>-->
        <!--                        </tr>-->
        <!--                        </tbody>-->
        <!--                    </table>-->
        <!--                </div>-->

        <div class="table-responsive">
          <div style="height: 100%">
            <div class="example-wrapper">
              <div class="example-header">
                <form class="d-flex mb-3" @submit.prevent="searchBlockList">
                  <input
                      v-model.trim="searchPhonenumber"
                      type="text"
                      name="phonenumber"
                      inputmode="numeric"
                      class="form-control"
                      id="filter-text-box"
                      placeholder="Enter mobile number"
                  >
                  <button type="submit" class="btn btn-primary ml-2">Search</button>
                </form>
              </div>
              <ag-grid-vue
                  domLayout="autoHeight"
                  style="width: 100%; height: 600px;"
                  class="ag-theme-alpine"
                  :columnDefs="columnDefs"
                  :defaultColDef="defaultColDef"
                  :rowData="rowData"
                  :context="context"
                  @grid-ready="onGridReady"
                  :frameworkComponents="frameworkComponents"
                  :pagination="true">
              </ag-grid-vue>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--    model begin-->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" data-backdrop="static"
         data-keyboard="false"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Add New Number to Block</h5>
            <button type="button" ref="modalClose" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit="onSubmit">
            <div class="modal-body">
              <div class="form-group">
                <label for="integration-phonenumber" class="col-form-label">Phone Number:<span
                    class="text-danger">*</span></label>
                <input type="text" class="form-control" minlength="10" maxlength="10"
                       v-model="form.phonenumber"
                       id="integration-phonenumber" placeholder="Enter phonenumber" required>
                <small> Enter 10 digit number except +91</small>
              </div>
              <div class="form-group">
                <label for="integration-token-id" class="col-form-label">Reason:<span
                    class="text-danger">*</span></label>
                <textarea class="form-control" id="integration-token-id" rows="2"
                          placeholder="Enter reason here..." minlength="5" maxlength="100"
                          v-model="form.reason" required></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--    model end-->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment/moment";
import {AgGridVue} from "ag-grid-vue3";  // the AG Grid Vue Component
// import { reactive, onMounted, ref } from "vue";
// import BtnCellRenderer from './btn-cell-renderer'
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css";
import UnblockButton from '../components/UnblockButtonRenderer.vue'

export default {
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      form: {
        phonenumber: '',
        reason: ''
      },
      tables: [],
      searchPhonenumber: '',
      show: true,
      columnDefs: [
        {
          headerName: '#',
          valueGetter: "node.rowIndex + 1",
          flex: 1
        },
        {
          headerName: 'PHONENUMBER',
          field: 'phonenumber',
          flex: 2
        },
        {
          headerName: 'REASON',
          field: 'reason',
          flex: 2
        },
        {
          headerName: 'CBY',
          field: 'cby',
          flex: 2
        },
        {
          headerName: 'TIMESTAMP',
          field: 'timestamp',
          flex: 2,
          valueFormatter: (params) => {
            if (params.value) {
              return moment(params.value).format('DD-MM-YYYY hh:mm:ss a')
            }
          }
        },
        {
          headerName: 'ACTION',
          field: 'action',
          cellRenderer: 'UnblockButton',
          flex: 2,
        }
        // {
        //     headerName: 'Action',
        //     cellRenderer: 'btnCellRenderer',
        //     cellStyle: { 'white-space': 'normal' },
        //     autoHeight: true,
        // }
      ],
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        sortable: true,
        flex: 1,
        editable: true,
      },
      rowData: [],
      context: null,
      frameworkComponents: {
        UnblockButton: UnblockButton
      },
    }
  },
  created() {
    this.context = {componentParent: this}
    this.end_loading();
  },
  methods: {
    async searchBlockList() {
      if (!this.searchPhonenumber) {
        this.tables = [];
        this.rowData = [];
        return;
      }

      this.begin_loading();
      try {
        const getTemp = await this.getNumberIntegrationList(this.searchPhonenumber);
        this.tables = getTemp.data.message || [];
        this.rowData = this.tables;
      } finally {
        this.end_loading();
      }
    },
    async onSubmit(event) {
      event.preventDefault()
      if (confirm('Are you sure to block?')) {
        this.begin_loading()
        var form = new FormData();
        form.append('phonenumber', this.form.phonenumber);
        form.append('reason', this.form.phonenumberId);
        // const config = {
        //   // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        //   // headers: {
        //   //   'Content-Type': 'multipart/form-data'
        //   // }
        // }
        const NMPUSER = JSON.parse(localStorage.getItem('NMPUSER'))
        if (!(localStorage.getItem('NMPUSER') && NMPUSER && Object.prototype.hasOwnProperty.call(NMPUSER, "token") && NMPUSER.token && NMPUSER.token == this.waId && NMPUSER.token != "")) {
          this.$router.push('/');
          return false;
        }
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': NMPUSER.token,
          }
        }
        await axios.post('/whatsApp/number_block',
            {
              phonenumber: this.form.phonenumber,
              reason: this.form.reason
            }, // the data to post
            config).then(response => {
          var responseTitle;
          if (response.data.status) {
            responseTitle = {title: "Success", icon: "success"};
          } else {
            responseTitle = {title: "Failed", icon: "error"};
          }
          this.$swal({
            title: responseTitle.title,
            html: response.data.message,
            icon: responseTitle.icon,
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        });
        this.end_loading()
        this.form = {
          phonenumber: '',
          reason: ''
        };
        this.$refs.modalClose.click();
        await this.refreshCurrentSearch();
      }
    },
    onReset(event) {
      event.preventDefault()
      // Reset our form values
      this.form.template = ''
      this.form.name = ''
      this.form.food = null
      this.form.checked = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    async getNumberIntegrationList(phonenumber) {
      // // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/number_block_list';
      return await this.axiosRequest(templateURL, {phonenumber: phonenumber});
    },
    async refreshCurrentSearch() {
      if (this.searchPhonenumber) {
        await this.searchBlockList();
      } else {
        this.tables = [];
        this.rowData = [];
      }
    },
    format_date(value) {
      if (value) {
        return moment(value).format('DD-MM-YYYY hh:mm:ss a');
      } else {
        return "";
      }
    },
    async integrationAction(index, mode) {
      this.form = {
        phonenumber: '',
        reason: ''
      };
      if (mode == 'edit') {
        this.form = this.tables[index]
      } else {
        // let phonenumber = this.tables[index].phonenumber
        let phonenumber = index
        this.$swal({
          title: 'Are you sure?',
          text: 'you going to unblock this number',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Unblock it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.isConfirmed) {
            let getAxiosRequest = await this.axiosRequest('/whatsApp/number_block_delete', {phonenumber: phonenumber});

            var responseTitle;
            if (getAxiosRequest.data.status) {
              responseTitle = {title: "Success", icon: "success"};
            } else {
              responseTitle = {title: "Failed", icon: "error"};
            }
            this.sweetAlert(responseTitle.icon, responseTitle.title, getAxiosRequest.data.message, 'btn-primary');
            await this.refreshCurrentSearch();
          }
        })
      }
    },
    openModelClickMethod() {
      this.form = {
        phonenumber: '',
        reason: ''
      };
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      setTimeout(() => {
        this.gridApi.sizeColumnsToFit() // test
      })
    }
  }
}
</script>
<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}

.bg-lightblue {
  background-color: lightblue;
}

/*td {*/
/*  white-space: normal !important;*/
/*  word-wrap: break-word;*/
/*}*/
/*table {*/
/*  table-layout: fixed;*/
/*}*/
</style>
